import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import CustomerBaseCarSharingStatus from './CustomerBaseCarSharingStatus';
import CustomerBaseCarSharingSubscriptions from './CustomerBaseCarSharingSubscriptions';
import CustomerBaseCarSharingSuspensions from './CustomerBaseCarSharingSuspensions';
import CustomerBaseCarSharingPayments from './CustomerBaseCarSharingPayments';
import CustomerBaseCarSharingInvoices from './CustomerBaseCarSharingInvoices';
import CustomerBaseCarSharingReservations from './CustomerBaseCarSharingReservations';
import { CarSharingProvider, useCarSharingContext } from './CarSharingContext';


function DisabledWrapper({
  disabled,
  children,
}: {
  disabled: boolean;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.6 : 1,
        transition: 'opacity 0.2s ease-in-out',
      }}
    >
      {children}
    </Box>
  );
}

function CarSharingContent() {
  const { isModDataAvailable } = useCarSharingContext();
  const disabled = !isModDataAvailable;

  return (
    <Box sx={{ overflow: 'auto' }}>
      <Grid container spacing={2} p={1} alignItems="start">
        <Grid item container md={6} xs={12} spacing={2}>
          <Grid item xs={12}>
            <CustomerBaseCarSharingStatus />
          </Grid>
          <Grid item xs={12}>
            <DisabledWrapper disabled={disabled}>
              <CustomerBaseCarSharingSubscriptions />
            </DisabledWrapper>
          </Grid>
          <Grid item xs={12}>
            <DisabledWrapper disabled={disabled}>
              <CustomerBaseCarSharingSuspensions />
            </DisabledWrapper>
          </Grid>
        </Grid>

        <Grid item container md={6} xs={12} spacing={2}>
          <Grid item xs={12}>
            <DisabledWrapper disabled={disabled}>
              <CustomerBaseCarSharingReservations />
            </DisabledWrapper>
          </Grid>
          <Grid item xs={12}>
            <DisabledWrapper disabled={disabled}>
              <CustomerBaseCarSharingPayments />
            </DisabledWrapper>
          </Grid>
          <Grid item xs={12}>
            <DisabledWrapper disabled={disabled}>
              <CustomerBaseCarSharingInvoices />
            </DisabledWrapper>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default function CustomerBaseCarSharingTab() {
  return (
    <CarSharingProvider>
      <CarSharingContent />
    </CarSharingProvider>
  );
}
